import { render } from "./NavForMember.vue?vue&type=template&id=641e94a3&scoped=true&ts=true"
import script from "./NavForMember.vue?vue&type=script&lang=ts"
export * from "./NavForMember.vue?vue&type=script&lang=ts"

import "./NavForMember.vue?vue&type=style&index=0&id=641e94a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641e94a3"]])

export default __exports__